import { Injectable } from '@angular/core';
import { ProjectModel } from '../../../../../core/models/project/project.model';
import { ProjectDataService } from '../../state-and-data-handling/project-data.service';
import { assert } from '../../../../../core/assert/assert';
import {
  BudgetOptions,
  ExpenditureOptions,
} from '../../../../../core/constants-repository/project-calculation.constants';
import { ProjectExpenditureBudgetTransformerService } from '../manage-project/project-calculation-form/services/project-expenditure-budget-transformer.service';
import { ExpenditureEntryService } from '../manage-project/project-calculation-form/services/expenditure-entry.service';
import { ProjectMemberGridRow } from '../../../shared/project-detail-types';
import { ExpenditureRateEntry } from '../../../../../core/models/project/project-expenditure-entry.model';

@Injectable({
  providedIn: 'root',
})
export class ProjectMemberService {
  constructor(
    private readonly projectDataService: ProjectDataService,
    private readonly projectExpenditureBudgetService: ProjectExpenditureBudgetTransformerService,
    private readonly expenditureEntryService: ExpenditureEntryService,
  ) {}

  public resetExpenditure(gridData: ProjectMemberGridRow[], dateFrom: Date): void {
    gridData.forEach((row, index) => {
      row.expenditureRateHistory = [
        this.expenditureEntryService.createExpenditureEntry(0, dateFrom, index),
      ];
    });
  }

  public resetBudget(gridData: ProjectMemberGridRow[]): void {
    gridData.forEach((row) => {
      row.budgetSeconds = 0;
    });
  }

  public syncProjectModel(gridData: ProjectMemberGridRow[], project: ProjectModel): void {
    const [expenditureEntries, budgetEntries] =
      this.projectExpenditureBudgetService.transformMemberGridDataToExpenditureAndBudgetEntries(
        gridData,
      );
    if (project.expenditureType === ExpenditureOptions.HourlyRatePerMember) {
      project.projectExpenditureEntries = expenditureEntries;
    }
    if (project.budgetType === BudgetOptions.HoursPerMember) {
      project.projectBudgetEntries = budgetEntries;
    }
    project.projectMemberPropertiesWrapper = gridData.map((row) => {
      return {
        member: row.member,
        deductCostsFromBudget: row.deductCostsFromBudget,
      };
    });
    this.projectDataService.updateProject(project);
  }

  public setHistoryForMember(
    gridData: ProjectMemberGridRow[],
    memberId: number,
    expenditureRateHistory: ExpenditureRateEntry[],
  ): void {
    const idx = gridData.findIndex((row) => row.member.id === memberId);
    const old = gridData[idx];
    assert(old !== undefined);

    const clone: ProjectMemberGridRow = { ...old };
    clone.expenditureRateHistory = expenditureRateHistory;
    gridData.splice(idx, 1, clone);
  }
}
